
import { useState } from "react";
import formatFileSize
, { formatDate }from "../../utils/formatFileSize";
     import {
    FolderOpen,
    Upload
} from "lucide-react";

import MediaActions
from "../actions/MediaActions";
import MediaPreviewDialog from "../dialogs/MediaPreviewDialog";
import ConfirmDialog from "../common/confirm/ConfirmDialog";
import useMedia from "../../hooks/useMedia";
import useToast from "../common/toast/useToast";

function getFileType(mimeType = "") {

    if (mimeType.startsWith("image/"))
        return "🖼 Image";

    if (mimeType.startsWith("video/"))
        return "🎥 Video";

    if (mimeType.startsWith("audio/"))
        return "🎵 Audio";

    if (mimeType.includes("pdf"))
        return "📄 PDF";

    if (mimeType.includes("word"))
        return "📝 Word";

    if (mimeType.includes("sheet"))
        return "📊 Excel";

    if (mimeType.includes("presentation"))
        return "📽 PPT";

    return "📁 File";

}

export default function MediaTable({

    rows = [],

    loading = true,

    onRefresh,onUpload,

    pickerMode = false,

    onSelect,

    isSelected,
    toggle,

    setDetailsOpen,

    setActiveMediaId

}) {

const [previewOpen,setPreviewOpen]=useState(false);
const [

    deleteOpen,

    setDeleteOpen

] = useState(false);
const [previewUrl,setPreviewUrl]=useState("");
const [media,setMedia]=useState({});

  const {


    deleteMedia

  } = useMedia();
  const toast =
      useToast();
  
  async function handleDelete(){

    
    try{


      await deleteMedia(
        media.id
      );

setDeleteOpen(false);

toast.success("File deleted successfully.");

onRefresh?.();

    }finally{

    }

  }

    if (loading) {

        return (
<div className="media-grid">
  

    {loading
      ? Array.from({ length: 12 }).map((_, i) => (
          <div
            key={i}
            className="media-card media-card-loading"
          >
            <div className="media-card-image skeleton" />

            <div className="media-card-body">

              <div className="skeleton skeleton-title" />

              <div className="skeleton skeleton-meta" />

              <div className="media-tags">
                <div className="skeleton skeleton-badge" />
                <div className="skeleton skeleton-badge" />
              </div>

              <div className="media-footer">
                <div className="skeleton skeleton-button" />
              </div>

            </div>
          </div>
        ))

      : rows.map(row => (

          <div
            key={row.id}
            className={`media-card ${
              isSelected(row.id)
                ? "selected-card"
                : ""
            }`}
            onClick={() => toggle(row.id)}
          >

            {/* Existing Card */}

          </div>

      ))}

</div> );

    }

    return (
<div> {
    rows.length === 0 && (
 
<div className="media-empty-card">

    <div className="media-empty-icon">

        <FolderOpen size={54} strokeWidth={1.6} />

    </div>

    <div className="media-empty-title">

        No media found

    </div>

    <div className="media-empty-subtitle">

        Try changing your search or filters, or upload a new file to your media library.

    </div>

    <button

        className="media-empty-btn"

        onClick={onUpload}

    >

        <Upload size={16} />

        Upload File

    </button>

</div>
    )
  }


          <div className="media-grid">

 
  {
    rows.map(row => (

      <div
        key={row.id}
        className={`media-card ${
          isSelected(row.id)
            ? "selected-card"
            : ""
        }`}
        onClick={() => toggle(row.id)}

        
      >

       <div className="media-card-image">

    {
        row.isImage
            ? (
                <img
                    src={row.previewUrl}
                    alt={row.original_name}
                    loading="lazy"
                />
            )
            : (
                <div className="media-placeholder">

                    {
                        row.isVideo
                            ? "🎥"
                            : row.isAudio
                            ? "🎵"
                            : row.isPdf
                            ? "📕"
                            : "📄"
                    }

                </div>
            )
    }

   <button
    type="button"
    className={`media-select-btn ${
        isSelected(row.id)
            ? "selected"
            : ""
    }`}
    onClick={e => {
        e.stopPropagation();
        toggle(row.id);
    }}
>
    {isSelected(row.id) && "✓"}
</button>

</div>

        <div className="media-card-body">

          <div className="media-title" style={{fontSize:"15px"}}>
            {row.original_name}
          </div>

          <div className="media-meta"><span>{row.mime_type}</span><span>{formatFileSize(row.size_bytes)}</span>
             
              <span>
                {formatDate(row.created_at)}
              </span>
            
          </div>

          <div className="media-tags">

            <span className="folder-badge">
              {row.folder || "-"}
            </span>

            <span className="type-badge">
              {getFileType(row.mime_type)}
            </span>

          </div>

          <div className="media-footer">

           

            <MediaActions
              media={row}
              onSelect={onSelect}
              setMedia={setMedia}
              onRefresh={onRefresh}
              setPreviewUrl={setPreviewUrl}
              setPreviewOpen={setPreviewOpen}
             deleteOpen={deleteOpen}
             setDeleteOpen={setDeleteOpen}

             onDetails={() => {

        setActiveMediaId(

            row.id

        );

        setDetailsOpen(true);

    }}
            />

          </div>

        </div>

      </div>

    ))
  }

      <ConfirmDialog

    open={deleteOpen}

    title="Delete File"

    message={`Delete "${media.original_name}" ?`}

    confirmText="Delete"

    onCancel={()=>

        setDeleteOpen(false)

    }

    onConfirm={handleDelete}

/>
  <MediaPreviewDialog
  
      open={previewOpen}
  
      media={media}
  
      url={previewUrl}
  
      onClose={()=>
  
          setPreviewOpen(false)
  
      }
  
  />
<style>{`.media-grid{

    display:grid;

    width:100%;

    min-width:0;

    gap:20px;

    grid-template-columns:repeat(4,minmax(0,1fr));

}

.media-card{

    width:100%;

    min-width:0;

    box-sizing:border-box;

}

@media(max-width:1200px){

.media-grid{

    grid-template-columns:repeat(3,1fr);

}

}

@media(max-width:992px){

.media-grid{

    grid-template-columns:repeat(2,1fr);

}

}

@media(max-width:640px){

.media-grid{

    grid-template-columns:1fr;

    gap:16px;

}

}
.media-card{

     width:100%;

    min-width:0;

    box-sizing:border-box;
    background:#FFF;

    border:1px solid #E5E7EB;

    border-radius:18px;

overflow:hidden;
       transition:
        transform .2s,
        box-shadow .2s,
        border-color .2s;

    cursor:pointer;

    box-shadow:0 6px 18px rgba(0,0,0,.05);

}

.media-card:hover{

    transform:translateY(-3px);

    border-color:#BFDBFE;

    box-shadow:

        0 15px 35px

        rgba(15,23,42,.10);

}

.selected-card{

    border:2px solid rgba(144, 202, 249,1);

    background:#EFF6FF;

}

.media-card-image{

    position:relative;

  width:100%;

    aspect-ratio:16/9;

    height:auto;

    background:#F3F4F6;

    overflow:hidden;

}

.media-card-image img{

    width:100%;

    height:100%;

    object-fit:cover;

}

.media-placeholder{

    width:100%;

    height:100%;

    display:flex;

    align-items:center;

    justify-content:center;

    font-size:56px;

}

.media-checkbox{

    position:absolute;

    top:12px;

    right:12px;

    width:20px;

    height:20px;

}

.media-card-body{

    padding:16px;

}

.media-title{

    font-size:15px;

    font-weight:600;

    color:#111827;

    white-space:nowrap;

    overflow:hidden;

    text-overflow:ellipsis;

}

.media-meta{
   display:flex; justify-content:left; gap:10px; 
    margin-top:6px;

    color:#6B7280;

    font-size:13px;

}

.media-tags{

    display:flex;

    gap:8px;

    margin-top:12px;

    flex-wrap:wrap;

}
.media-card-image{

    position:relative;


    background:#F8FAFC;

    display:flex;

    align-items:center;

    justify-content:center;

    overflow:hidden;

}

.media-card-image img{

    width:100%;

    height:100%;

    object-fit:cover;

}
.folder-badge,
.type-badge{

    padding:5px 10px;

    border-radius:999px;

    background:#F3F4F6;

    font-size:12px;

    font-weight:600;

}

.media-footer{

    margin-top:18px;

    display:flex;

    justify-content:space-between;

    align-items:center;

    font-size:13px;

}

.media-empty-card{

    width:90%;

    padding:80px;

    text-align:center;

    background:#FFF;

    border-radius:18px;

    border:1px solid #E5E7EB;

}

.media-empty-title{

    font-size:20px;

    font-weight:700;

}

.media-empty-subtitle{

    margin-top:10px;

    color:#6B7280;

}

/* Tablet */

@media(max-width:1024px){

    .media-card{

        width:calc(90% - 10px);

    }

}

/* Mobile */

@media(max-width:640px){

    .media-card{

        width:100%;

    }

}.skeleton{

    position:relative;

    overflow:hidden;

    background:#ECEFF3;

    border-radius:8px;

}

.skeleton::after{

    content:"";

    position:absolute;

    top:0;
    left:-150px;

    width:150px;
    height:100%;

    background:
    linear-gradient(
        90deg,
        transparent,
        rgba(255,255,255,.7),
        transparent
    );

    animation:
        skeleton-loading
        1.2s
        infinite;

}

@keyframes skeleton-loading{

    100%{

        left:100%;

    }

}

.media-card-loading{

    pointer-events:none;

}

.media-card-loading
.media-card-image{

    width:100%;
    height:180px;

}

.skeleton-title{

    height:18px;

    width:75%;

    margin-top:16px;

}

.skeleton-meta{

    height:14px;

    width:55%;

    margin-top:12px;

}

.skeleton-badge{

    width:70px;

    height:26px;

    border-radius:20px;

}

.skeleton-button{

    width:100%;

    height:38px;

    margin-top:12px;

}
.media-select-btn{

    width:22px;
    height:22px;

    border-radius:7px;

    border:2px solid #CBD5E1;

    background:#FFF;

    display:flex;

    align-items:center;
    justify-content:center;

    cursor:pointer;

    transition:all .18s ease;

    font-size:13px;
    font-weight:700;

    color:#FFF;
position:absolute;top:10px;right:20px;z-index:999;
    flex-shrink:0;

}

.media-select-btn:hover{

    border-color:rgba(144, 202, 249,1);

    background:#EFF6FF;

    transform:scale(1.05);

}

.media-select-btn.selected{
    
    background:rgba(144, 202, 249,1);

    border-color:rgba(144, 202, 249,1);

    box-shadow:0 0 0 3px rgba(37,99,235,.12);

}.media-empty-card{

    display:flex;

    flex-direction:column;

    align-items:center;

    justify-content:center;

    gap:14px;

    min-height:340px;

    padding:40px;

    background:#FFF;

    border:1px dashed #CBD5E1;

    border-radius:20px;

    text-align:center;

}

.media-empty-icon{

    width:90px;

    height:90px;

    border-radius:50%;

    display:flex;

    align-items:center;

    justify-content:center;

    background:#EFF6FF;

    color:rgba(144, 202, 249,1);

}

.media-empty-title{

    font-size:22px;

    font-weight:700;

    color:#0F172A;

}

.media-empty-subtitle{

    max-width:420px;

    color:#64748B;

    line-height:1.6;

    font-size:15px;

}

.media-empty-btn{

    margin-top:8px;

    height:44px;

    padding:0 18px;

    border:none;

    border-radius:12px;

    display:flex;

    align-items:center;

    gap:8px;

    background:rgba(144, 202, 249,1);

    color:#FFF;

    font-size:14px;

    font-weight:600;

    cursor:pointer;

    transition:.2s;

}

.media-empty-btn:hover{

    background:#1D4ED8;

}
`}</style>
</div>

</div>
    );

}